export const WeekOptionsModel = [
    { weeks: 4, name: "4 uger frem" },
    { weeks: 5, name: "5 uger frem" },
    { weeks: 6, name: "6 uger frem" },
    { weeks: 7, name: "7 uger frem" },
    { weeks: 8, name: "8 uger frem" },
    { weeks: 9, name: "9 uge frem" },
    { weeks: 10, name: "10 uger frem" },
    { weeks: 11, name: "11 uger frem" },
    { weeks: 12, name: "12 uger frem" },
    { weeks: 13, name: "13 uger frem" },
];
